import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { Icon } from "@mc/mc-legacy";
import "./IconButton.scss";

/**
 * IconButton.
 */
const IconButton = ({ color, icon, title, onClick }) => {
  return (
    <div className="icon-button">
      <Button color={color} className="btn-icon" onClick={onClick}>
        <div className="icon-box">
          <Icon icon={icon} />
        </div>
        {title}
      </Button>
    </div>
  );
};

IconButton.defaultProps = {
  color: "primary",
};
IconButton.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};
export default IconButton;
